/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.sherpa.activities.b2b.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers'
])

.controller('SherpaActivitiesB2BController', ['$scope', '$state', 'ApiService', 'HelpersService', function($scope, $state, ApiService, HelpersService) {

    $scope.sherpaActivitiesB2B = {
      activity: [],
      tenantId: '',
      deputyId: '',
      init: function () {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Tenant'
        });

        if ($state.params.hasOwnProperty('tenantId')) {
          $scope.sherpaActivitiesB2B.tenantId = $state.params.tenantId;
        }
        $scope.sherpaActivitiesB2B.getTenantActivity();
      },
      getTenantActivity: function() {
        ApiService.customerService.getTenantB2BActivity($scope.sherpaActivitiesB2B.tenantId, $scope.sherpaActivitiesB2B.deputyId).
          then($scope.sherpaActivitiesB2B.success.getTenantActivity,$scope.sherpaActivitiesB2B.error.getTenantActivity);
      },
      success: {
        getTenantActivity: function(response) {
          $scope.sherpaActivitiesB2B.activity = response.data.payload;
        }
      },
      error: {
        getTenantActivity: function(response) {

        }
      }
    };
    $scope.sherpaActivitiesB2B.init();

    $scope.gridOptions = {
      multiselect: false,
      enableRowSelection: false,
      paginate: true,
      showFooter: true,
      pageSize: 50,

      columnDefs: [
        {
          field: 'createdOn',
          displayName: 'Date',
          sort: {
            direction: 'desc'
          }
        },
        {
          field: 'activity',
          displayName: 'Activity'
        },
        {
          field: 'logData',
          displayName: 'Data'
        },
        {
          field: 'customerServiceId',
          displayName: 'CSR ID'
        }
      ]
    };

}]);